import { CallLogApi, CallLogDetails, CallLogParticipant } from 'apis/CallLogApi';
import moment from 'moment-timezone';
import { useEffect, useState, FC } from 'react';
import { useDispatch } from 'react-redux';
import styled from 'styled-components';
import AuthStore from '../../stores/AuthStore';
import Message from '../../utils/Message';
//import { getProviderStrings } from '../../utils/providerApi';

import { UIModal, UINucleusContainer } from '../UI';
import { UICard } from '../UI';
import { UINucleusContentContainer } from '../UI/NucleusContainer/Content';

export type tProviderCallLogData = {
  ID: string;
  CallRequestID?: string;
  StartTime: string;
  EndTime?: string;
  WasAnswered: boolean;
  Notes?: string | null;
  AccountID: string;
  Status: string;
  IsHipaa: boolean;
  UserID?: string;
  UserName?: string;
  Participant?: string | null;
  RequestedByUserID?: string | null;
};

interface Props {
  openModal: () => void;
  closeModal: () => void;
  isOpen: boolean;
  callLogId?: string | null;
}

const PostCallNotesModal: FC<Props> = ({ openModal, closeModal, isOpen, callLogId }) => {
  const dispatch = useDispatch();

  const [callLogData, setcallLogData] = useState<CallLogDetails | null>(null);
  const [callLogParticipants, setcallLogParticipants] = useState<CallLogParticipant[] | undefined>([]);

  const [callLogNotes, setCallLogNotes] = useState<string>('');
  const [notesError, setNotesError] = useState<string>('');

  const [userRoleName, setUserRoleName] = useState<string>('');

  useEffect(() => {
    if (callLogId) {
      fetchCallLogData(callLogId);
    }
  }, [callLogId]);

  useEffect(() => {
    async function fetchProviderStrings() {
      const UserRoleName = 'User'; //await getProviderStrings(providerId);
      setUserRoleName(UserRoleName);
    }
    fetchProviderStrings();
  }, []);

  const fetchCallLogData = async (callLogId: string) => {
    const { data: responseData } = await CallLogApi.getCallLog({ callLogId });
    console.log('fetchCallLogData', responseData);
    if (responseData?.callLogData?.WasAnswered) {
      openModal();
    } else {
      cleanAndClose();
      return;
    }
    if (responseData?.callLogData) {
      setcallLogData(responseData?.callLogData);
      setCallLogNotes(responseData?.callLogData?.Notes || '');
    }
    if (responseData?.callLogData?.Participants) {
      setcallLogParticipants(responseData?.callLogData?.Participants);
    }
  };

  const updatePostCallLogData = async () => {
    if (!callLogId) return;

    // Require notes
    if (!callLogNotes || callLogNotes.trim().length === 0) {
      setNotesError('Notes are required');
      Message.show('Please enter notes before completing.');
      return;
    }

    const updateCallLogInfo: {
      callLogId: string;
      notes: string;
      userId: string;
    } = {
      notes: callLogNotes.trim(),
      callLogId,
      userId: AuthStore.getUserID(),
      // intentionally omitting reason/type/outcome per new requirement
    };

    try {
      await CallLogApi.updateCallLog({ callLogId, ...updateCallLogInfo });
      cleanAndClose();
      Message.show('Call notes saved');
    } catch (error) {
      Message.show('There was a problem saving notes. Please try again.');
    }
  };

  const onRepeatCall = () => {
    // if (callLogData?.Participant) {
    //   const callParticipant = JSON.parse(callLogData.Participant);
    //   const patientId = callParticipant.PatientID.toLowerCase();
    //   const patientName = callParticipant.FirstName + ' ' + callParticipant.LastName;
    //   const deviceId = callParticipant.DeviceID.toLowerCase();
    //   const entityId = (callLogData.RequestedByUserID ? callLogData.RequestedByUserID : patientId).toLowerCase();
    //   const callType = AuthStore.nucleusAutomaticCallRequestBargeIn ? CallType.BargeIn : CallType.Video;
    //   const participants: FullCallEntity[] = [
    //     {
    //       devicesIds: [deviceId],
    //       name: patientName,
    //       entityId,
    //       host: false,
    //       status: 'connected',
    //       type: callType,
    //     },
    //   ];
    //   const callData: WebRTCCall = {
    //     requestId: callLogData.CallRequestID || '',
    //     patientId: patientId,
    //     entityId,
    //     callingMethod: CallingMethods.Notify,
    //     participants,
    //     multiCall: false,
    //     patientFirstName: callParticipant.FirstName,
    //     patientLastName: callParticipant.LastName,
    //     calleeFirstName: callParticipant.FirstName,
    //     calleeLastName: callParticipant.LastName,
    //     patientName,
    //     deviceName: callParticipant.DeviceName || null,
    //     patientThumb: '',
    //     callerName: `${userRoleName || 'User'} is calling you`,
    //     type: callType,
    //   };
    //   cleanAndClose();
    //   dispatch(startCall(callData));
    // }
  };

  const cleanAndClose = () => {
    setCallLogNotes('');
    setNotesError('');
    closeModal();
  };

  console.log('isOpen:--------', isOpen);

  return (
    <UIModal
      close={closeModal}
      isOpen={isOpen}
      size="mediumLarge"
      title="Post Call Notes"
      dismissable={false}
      actions={[
        {
          label: 'Complete',
          onClick: () => updatePostCallLogData(),
          disabled: false,
          buttonVariant: 'primary',
        },
      ]}
    >
      <UINucleusContainer style={{ overflowY: 'auto', maxHeight: '80vh', paddingLeft: 5, paddingRight: 10 }}>
        <UINucleusContentContainer style={{ paddingBottom: 6 }}>
          <UICard style={{ width: '100%', backgroundColor: '#FFFFFF', marginBottom: 18 }}>
            <div style={{ display: 'flex' }}>
              <div style={{ display: 'flex', flex: 1, flexDirection: 'column', gap: 10 }}>
                <InfoField label="Date" value={callLogData?.StartTime ? moment(callLogData.StartTime).format('dddd, MMMM D, YYYY') : ''} />
                <InfoField label="Time Started" value={callLogData?.StartTime ? moment(callLogData.StartTime).format('LTS') : ''} />
                <InfoField label="Time ended" value={callLogData?.EndTime ? moment(callLogData.EndTime).format('LTS') : ''} />
                <InfoField label="Call status" value={callLogData?.Status || ''} />
                <InfoField label="Call participants" value={callLogParticipants[0]?.Description} />
                <InfoLine label="" value={callLogParticipants[1]?.Description} />
              </div>
              {/* <div>{callLogData?.Participant && <UISmallButton onClick={onRepeatCall} text={'Call again'} variant={'secondary'} />}</div> */}
            </div>
          </UICard>

          <InfoLabel>Notes</InfoLabel>
          <UICard style={{ display: 'flex', width: '100%', backgroundColor: '#FFFFFF', marginTop: 5 }}>
            <NotesTextArea
              placeholder="Enter notes..."
              value={callLogNotes}
              onChange={e => {
                setCallLogNotes(e.target.value);
                if (notesError) setNotesError('');
              }}
              aria-invalid={!!notesError}
              aria-describedby={notesError ? 'post-call-notes-error' : undefined}
            />
          </UICard>
          {notesError && (
            <ErrorText id="post-call-notes-error" role="alert">
              {notesError}
            </ErrorText>
          )}
        </UINucleusContentContainer>
      </UINucleusContainer>
    </UIModal>
  );
};

export type tPostCallData = {};

const InfoLabelContainer = styled.div`
  display: flex;
  width: 100%;
  flex: 1;
`;
const InfoLabel = styled.span`
  display: flex;
  flex: 2;
  font-family: Barlow;
  font-size: 16px;
  font-weight: 600;
  line-height: 19px;
  letter-spacing: 0px;
  text-align: left;
`;
const InfoValue = styled.span`
  display: flex;
  flex: 4;
`;
const InfoField = ({ label = '', value = '' }: { label: string; value: string }) => {
  return (
    <InfoLabelContainer>
      <InfoLabel>{label}:</InfoLabel>
      <InfoValue>{value}</InfoValue>
    </InfoLabelContainer>
  );
};
const InfoLine = ({ label = '', value = '' }: { label: string; value: string }) => {
  return (
    <InfoLabelContainer>
      <InfoLabel></InfoLabel>
      <InfoValue>{value}</InfoValue>
    </InfoLabelContainer>
  );
};

const NotesTextArea = styled.textarea`
  font-family: Barlow;
  width: 100%;
  min-height: 112px;
  resize: none;
  border: none;
  outline: none;
  box-sizing: border-box;
  box-shadow: none;
  padding: 8px;
  &[aria-invalid='true'] {
    outline: 2px solid #dc2626;
    outline-offset: -2px;
  }
`;

const ErrorText = styled.div`
  margin-top: 6px;
  color: #dc2626;
  font-size: 12px;
`;

export default PostCallNotesModal;
